import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function variableLengthValidator(
  maxLength: number
): (control: AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value && value.length > maxLength) {
      return { maxLengthExceeded: true };
    }

    return null;
  };
}
export function contactNumberValidator(control: AbstractControl): ValidationErrors | null {
  const value = control?.value;
  const contactNumberPattern = /^\+[0-9]*$/;
  if (value) {
    if (!contactNumberPattern.test(value)) {
      return { invalidCharacters: true };
    }

    if (value.length < 8) {
      return { minLength: true };
    }
  }
  return null;
}
export function noSpacesSpecialcharacterValidator(): (control: AbstractControl) => ValidationErrors | null {

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value) {

      const regex = /^[^\s!@#$%^&*,.?":{}|<>]*$/u;
      if (!regex.test(value)) {
        return { invalidCharacters: true };
      }
    }

    return null;
  };
}

export function latinAlphabetValidator(control: AbstractControl): ValidationErrors | null {
  const value = control?.value;
  const latinAlphabetPattern = /^(?!\s)[A-Za-z0-9\s!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]*$/;
  if (value && !latinAlphabetPattern.test(value)) {
    return { invalidValue: true };
  }
  return null;
}

export function noOnlySpacesOrSpecialCharactersValidator(): (control: AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value) {
      const trimmedValue = value.trim();
      // Regex to ensure at least one letter or number from any language is present
      const regex = /\p{L}|\p{N}/u;
      if (!regex.test(trimmedValue)) {
        return { invalidValue: true }; // Invalid if no letters or numbers
      }
    }

    return null; // Valid input
  };
}

export function eitherBuyerTinOrIdentificationNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const buyerTinAvailable = control.get('buyerTinAvailable')?.value;
    const identificationNumberAvailable = control.get(
      'identificationNumberAvailable'
    )?.value;
    const customerType = control.get('customerType')?.value;
   if (customerType != 'nonIndividual' && customerType !== 'foreignNonIndividual') {
      if (
        buyerTinAvailable === 'no' &&
        identificationNumberAvailable === 'no'
      ) {
        return { eitherBuyerTinOrIdentificationNumberValidator: true }; // Return an error if both are 'no'
      }
    }

    return null; // No error if the condition is not met
  };
}

export function emailValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value || '';

  // Ensure no spaces and a valid email structure with regex
  //const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  const emailRegex = /^(?![.;])([A-Za-z0-9+_!$%|'*^/&=?{}.#:,\-()\[\]<>\\"]+(?:\.[A-Za-z0-9+_!$%|'*^/&=?{}.#:,\-()\[\]<>\\"]+)*)@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{1,}(?<![.;])$/;
  if (!value) {
    return { required: true }; // If empty, mark as required
  }

  if (!emailRegex.test(value)) {
    return { invalidEmail: true }; // If regex fails, mark as invalid email
  }

  if (value.length > 320) {
    return { maxLengthExceeded: true }; // If email is too long
  }
  if (value.includes(' ')) {
    return { invalidSpace: true };
  }
  return null; // If all checks pass
}

export function postCodeValidator(getCountry: () => string, maxLength: Number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value || '';
    const country = getCountry();

    if (country === 'Malaysia') {
      // Validation for Malaysia: Max 5 numeric characters
      const malaysiaPostCodePattern = /^([0-9]{1,5})?$/;
      if (!malaysiaPostCodePattern.test(value)) {
        return { invalidPostCodeMalaysia: true };
      }
    } else {
      // Validation for other countries: Max 50 characters
      if (value.length > maxLength) {
        return { maxLengthExceeded: true };
      }
    }

    return null; // Valid input
  };
}
